import actions from './actions';
import axios, { CancelToken } from '../axios';
import store from '../store';
import { message } from 'antd';
import errorHandling from '../error';
import { getHeaders } from '../../utils/common';

const {
  getReferralBegin, getReferralSuccess, getReferralFailed,
  addReferralBegin, addReferralSuccess, addReferralFailed,
  updateReferralBegin, updateReferralSuccess, updateReferralFailed,
  deleteReferralBegin, deleteReferralSuccess, deleteReferralFailed,
} = actions;


// GETTING ALL REFERRALS
let cancelToken;
export const getAllReferrals = filter => async (dispatch) => {
  if (cancelToken) cancelToken.cancel();
  cancelToken = CancelToken.source();
  try {
    dispatch(getReferralSuccess({ referrals: [] }));
    dispatch(getReferralBegin());
    const res = await axios.get(`referral${filter ? filter : ''}`, { headers: { ...getHeaders() }, cancelToken: cancelToken.token });
    dispatch(getReferralSuccess(res.data));
  } catch (err) {
    dispatch(getReferralFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err, false))
  }
}

// ADDING NEW REFERRAL
export const addNewReferral = (data, form) => async (dispatch) => {
  try {
    const state = store.getState();
    dispatch(addReferralBegin());
    const res = await axios.post('referral', data, { headers: { ...getHeaders() } });

    dispatch(addReferralSuccess([res.data.referral, ...state.referral.referrals]));
    message.success('New Referral created successfully');
    form.resetFields();
  } catch (err) {
    dispatch(addReferralFailed(err?.message));
    dispatch(errorHandling(err))
  }
}

// UPDATING REFERRAL
export const editReferral = (id, datas) => async (dispatch) => {
  try {
    dispatch(updateReferralBegin());
    await axios.put(`referral/${id}`, datas, { headers: { ...getHeaders() } });

    const { referrals } = store.getState().referral;
    const updated = referrals.map(r =>
      r._id === id ? { ...r, ...datas } : r
    );
    
    dispatch(updateReferralSuccess(updated));
    message.success('Referral updated successfully')
  } catch (err) {
    dispatch(updateReferralFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err))
  }
}

// DELETE REFERRAL
export const deleteReferral = id => async (dispatch) => {
  try {
    const state = store.getState();
    dispatch(deleteReferralBegin());
    await axios.delete(`referral/${id}`, { headers: { ...getHeaders() } });

    dispatch(deleteReferralSuccess(state.referral.referrals.filter(data => data._id !== id)));
    message.success('Referral deleted successfully')
  } catch (err) {
    dispatch(deleteReferralFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err))
  }
} 